<template>
  <div>
    <div class="slide-show" @mouseover="clearInv" @mouseout="runInv">
      <div class="slide-img">
        <transition name="slide-fade">
          <img v-if="isShow" :src="slides[nowIndex].src" @click="show(nowIndex)" />
        </transition>
        <transition name="slide-fade-old">
          <img v-if="isShows" :src="slides[nowIndex].src" @click="show(nowIndex)" />
        </transition>
      </div>
      <div class="slide-title">
        <a>{{ slides[nowIndex].title}}</a>
      </div>
      <ul class="slide-pages">
        <li v-for="(item, index) in slides" :key="index" @click="goto(index)">
          <a :class="{on: index === nowIndex}"></a>
        </li>
      </ul>
      <a @click="goto(prevIndex)" class="callbacks-nav">＜</a>
      <a @click="goto(nextIndex)" class="callbacks-nav next">＞</a>
    </div>
    <!-- 图片查看 -->
    <viewer :images="images" @inited="inited" class="viewer" ref="viewer">
      <template slot-scope="scope">
        <img v-for="(src,index) in scope.images" :src="src" :key="index" />
        {{scope.options}}
      </template>
    </viewer>
  </div>
</template>

<script>
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer/src/component.vue";
export default {
  name: "sliderShow",
  components: {
    Viewer
  },
  props: {
    slides: {
      type: Array,
      default: function() {
        return [];
      }
    },
    inv: {
      type: Number,
      default: 1000
    }
  },
  data() {
    return {
      nowIndex: 0,
      isShow: true,
      isShows: false,
      images: []
    };
  },
  computed: {
    prevIndex() {
      if (this.nowIndex === 0) {
        return this.slides.length - 1;
      } else {
        return this.nowIndex - 1;
      }
    },
    nextIndex() {
      if (this.nowIndex === this.slides.length - 1) {
        return 0;
      } else {
        return this.nowIndex + 1;
      }
    }
  },
  methods: {
    goto(index) {
      this.isShow = false;
      setTimeout(() => {
        this.nowIndex = index;
        this.isShows = true;
      }, 10);
    },
    runInv() {
      this.invId = setInterval(() => {
        this.goto(this.nextIndex);
      }, this.inv);
    },
    clearInv() {
      clearInterval(this.invId);
    },
    inited(viewer) {
      this.$viewer = viewer;
    },
    show(idx) {
      // viewer.show()改为$viewer。view(i)
      this.$viewer.view(idx);
    }
  },
  mounted() {
    this.runInv();

    this.$watch("slides", function() {
      let allImages = [];
      for (var i = 0; i < this.slides.length; i++) {
        if (this.slides[i].src) {
          allImages.push(this.slides[i].src);
        }
      }
      this.images = allImages;
    });
  }
};
</script>

<style scoped>
.slide-show {
  margin-bottom: 2px;
  position: relative;
  width: 96%;
  max-width: 96%;
  text-align: center;
}
.slide-img {
  position: relative;
  list-style: none;
  overflow: hidden;
  width: 100%;
  padding: 0;
  margin: 0;
}
.slide-img li {
  position: relative;
  display: block;
  float: left;
}
.slide-img li a {
  display: block;
  overflow: hidden;
}
.slide-img img {
  display: block;
  position: relative;
  z-index: 1;
  height: auto;
  width: 100%;
  border: 0;
}
.slide-title {
  position: absolute;
  bottom: 0;
  z-index: 99;
  height: 40px;
  width:100%;
  background: #2c3e50;
  opacity: 0.7; 
}
.slide-title a {
  line-height: 40px;
  color: #fff;
  opacity: 1;
  display: block;
  float: left;
  text-align: left;
  background: #2c3e50;
  padding:0 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.slide-pages {
  position: absolute;
  bottom: 0;
  right: 12px;
  z-index: 100;
  height: 40px;
  line-height: 1;    
  display: flex;
  align-items: center;
}
.slide-pages li {
  float: left;
}
.slide-pages li a {
  display: block;
  width: 12px;
  height: 12px;
  margin-left: 5px;
  border-radius: 12px;
  border: 1px solid #fff;
  cursor: pointer;
}
.slide-pages li .on {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-left: 5px;
  border-radius: 12px;
  position: relative;
  background: #fff;
}
.callbacks-nav {
  position: absolute;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  top: 50%;
  left: 0;
  z-index: 3;
  overflow: hidden;
  text-decoration: none;
  height: 61px;
  width: 38px;
  background: #2c3e50;
  color: #fff;
  opacity: 0.4;
  text-align: center;
  line-height: 61px;
  margin-top: -30px;
  font-weight: bolder;
  display: none;
  cursor: pointer;
}
.callbacks-nav:active {
  opacity: 1;
}
.slide-show:hover .callbacks-nav {
  display: block;
}
.callbacks-nav:hover {
  opacity: 0.7;
}
.next {
  left: auto;
  right: 0;
}
</style>
